import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import {
  getIncludedInGroups,
  getLoggedInUser,
  getSimoDevice,
  getUser,
} from '../reducers';

const withSimoDevice = (DecoratedComponent) => {
  let WithSimoDevice = ({ children, ...props }) => {
    return React.createElement(DecoratedComponent, props, children);
  };

  const mapStateToProps = (
    state,
    {
      match: {
        params: { deviceId },
      },
    },
  ) => {
    const simoDevice = getSimoDevice(state, deviceId);
    const userId = simoDevice?.user_profile;
    return {
      simoDevice,
      simoDeviceId: deviceId,
      user: getUser(state, userId),
      loggedInUser: getLoggedInUser(state),
      isReseller: getIncludedInGroups(state, ['RESELLER']),
      isAdminOrManager: getIncludedInGroups(state, ['ADMIN', 'MANAGER']),
    };
  };

  WithSimoDevice = withRouter(connect(mapStateToProps, null)(WithSimoDevice));

  const WithSimoDeviceRoute = ({ children, ...props }) => (
    <Route
      path="/simo/devices/:deviceId"
      component={WithSimoDevice}
      {...props}
    />
  );

  return WithSimoDeviceRoute;
};

export default withSimoDevice;
